module.exports = {
  ownerId: '11111111111111111111111111111111',
  contractId: 'rUnsWrFu3PKyRMGk2mxmZVBPbQuZx2qtHeFjURoQevX',
};
